//import package from node modules
import {useContext} from "react";
import { useLocation, useHistory } from 'react-router-dom'

//import utility functions
import {DOMAIN_TYPE, SHARED_HOSTING_TYPE} from "../../../../utilities/function/servicetype"

import {
    ADD_DOMAIN_PAGE,
    ADD_PRODUCT_PAGE,
    EDIT_DOMAIN_PAGE,
    EDIT_PRODUCT_PAGE,
    getSlugByName
} from "../../../../utilities/function/common"

import {
    getCartToken
} from "../../../../utilities/function/cartToken"

import {
    getCID,
    getDataFromURL,
    getPageByURL
} from "../../../../utilities/function/urlparams"

import {
    getDomainNamePayloadFromConfig,
    isLastStep,
    getAttributes,
    getFilteredConfigurationList
} from "../../../../utilities/function/configuration"

import {
    addItemToCart,
    bulkActionCart,
    editProductPage,
    loadConfiguration,
    updateCartItem
} from "../../../../app/action"


//import internals
import {AUTO_RENEW, EPP_CODE, ID_PROTECTION,getUpsell} from "./index"
import {SelectDomainConfigContext} from "./reducer";
import {useSelector,useDispatch} from "react-redux";

let timeoutOnSubmit = null

export default () => {
    //define variables
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()
    const pageType = getPageByURL(location.search)
    const cid = getCID(getDataFromURL(location.search))
    const context = useContext(SelectDomainConfigContext)
    const {state} = context
    const {requestUpsellData} = state
    const {cartData} = useSelector(state=>({
        cartData: state.app.cartData
    }))

    //define functions
    const formValuesAreDefined = (values) => {
        return values && values.domain_config && Array.isArray(values.domain_config)
    }
    const getCustomFieldsData = (dataInput, productConfig) => {
        const customfields = []
        if (dataInput && Object.keys(dataInput).length) {
            Object.keys(dataInput).forEach(slug => {
                if (productConfig && getAttributes(productConfig.selectedProduct)) {
                    const {custom_fields} = getAttributes(productConfig.selectedProduct)
                    if (custom_fields && Array.isArray(custom_fields) && custom_fields.length > 0) {
                        const selectedCustomfield = custom_fields.find(item => getSlugByName(item.name) === slug)
                        if (selectedCustomfield) {
                            const customfieldvalue = {
                                id: selectedCustomfield.id,
                                value: dataInput[slug]
                            }
                            customfields.push(customfieldvalue)
                        }
                    }
                }
            })
        }
        return customfields
    }
    const getMetaFields = (dataInput) => {
        const used_meta_fieds = [
            ID_PROTECTION,
            AUTO_RENEW,
            EPP_CODE
        ]
        const meta = {}
        if (dataInput && Object.keys(dataInput) && Object.keys(dataInput).length > 0) {
            Object.keys(dataInput).forEach(key => {
                if (used_meta_fieds && used_meta_fieds.length > 0) {
                    used_meta_fieds.forEach(metaname => {
                        if (getSlugByName(metaname) === key) {
                            meta[getSlugByName(metaname)] = dataInput[key]
                        }
                    })
                }
            })
        }
        return meta
    }

    //define update configuration functions
    const getNewConfigurationsOnDomainPage = (dataInput,newconfigurations) => {
        const {billing_cycle_id,domain,tld} = dataInput
        const domain_cid = domain + tld
        const {uuid} = getDataFromURL(location.search)
        const productConfig = uuid? newconfigurations[uuid] : newconfigurations[domain_cid]
        const custom_fields = getCustomFieldsData(dataInput, productConfig)
        const meta_fields = getMetaFields(dataInput, productConfig)
        const updatedConfigurations = {
            ...productConfig,
            ...meta_fields,
            custom_fields,
            billing_cycle_id
        }
        if(pageType===ADD_DOMAIN_PAGE){

            newconfigurations[domain_cid] = updatedConfigurations
        }else {
            newconfigurations[uuid] = updatedConfigurations
        }
        return newconfigurations
    }
    const getNewConfigurationsOnProductPage = (dataInput,newconfigurations) => {
        const {billing_cycle_id,domain,tld} = dataInput
        const domain_cid = domain + tld
        const domainConfig = newconfigurations[domain_cid]
        const custom_fields = getCustomFieldsData(dataInput, domainConfig)
        const meta_fields = getMetaFields(dataInput, domainConfig)
        const upsells = getUpsell(dataInput, requestUpsellData)
        newconfigurations[domain_cid] = {
            ...domainConfig,
            ...meta_fields,
            custom_fields,
            billing_cycle_id
        }
        if (upsells && Object.keys(upsells).length > 0) {
            newconfigurations = {
                ...newconfigurations,
                ...upsells
            }
        }
        if (pageType === ADD_PRODUCT_PAGE || pageType === EDIT_PRODUCT_PAGE) {
            if (cid) {
                newconfigurations[cid] = {
                    ...newconfigurations[cid],
                    name: domain_cid
                }
            }
        }
        return newconfigurations
    }

    //define process configuration functions
    const processConfigurationsOnAddProductPage = (newconfigurations) => {
        if (newconfigurations[cid]
            && newconfigurations[cid].breadcrumbs
            && newconfigurations[cid].step
            && isLastStep(newconfigurations[cid].breadcrumbs, newconfigurations[cid].step)
        ) {
            addItemToCart(newconfigurations[cid], dispatch, history, newconfigurations,location)
        } else {
            newconfigurations[cid] = {
                ...newconfigurations[cid],
                step: newconfigurations[cid].step ? newconfigurations[cid].step + 1 : 1
            }
            timeoutOnSubmit = window.setTimeout(()=>{
                loadConfiguration(newconfigurations, dispatch)
            },500)
        }
    }
    const processConfigurationsOnEditProductPage = (newconfigurations) => {
        if(isLastStep(newconfigurations[cid].breadcrumbs,newconfigurations[cid].step)){
            editProductPage(cid,newconfigurations,cartData,dispatch,location,history)
        }else{
            newconfigurations[cid] = {
                ...newconfigurations[cid],
                step: newconfigurations[cid].step ? newconfigurations[cid].step + 1 : 1
            }
            timeoutOnSubmit = window.setTimeout(()=> {
                loadConfiguration(newconfigurations, dispatch)
            },500)
        }
    }
    const processConfigurationsOnAddDomainPage = (newconfigurations) => {
        //check when upsell products have been loaded
        if (state && state.requestUpsellStatus === 'success') {
            const domainList = getFilteredConfigurationList(DOMAIN_TYPE, newconfigurations)
            const upsellList = getFilteredConfigurationList(SHARED_HOSTING_TYPE, newconfigurations, false, true,true)
            const list = domainList.concat(upsellList)
            addItemToCart(list, dispatch, history, newconfigurations,location)
        }else{
            const domainList = getFilteredConfigurationList(DOMAIN_TYPE, newconfigurations)
            addItemToCart(domainList, dispatch, history, newconfigurations,location)
        }
    }
    const processConfigurationsOnEditDomainPage = (newconfigurations) => {
        //check when upsell products have been loaded
        if (state && state.requestUpsellStatus === 'success') {
            const {uuid} = getDataFromURL(location.search)
            const domainItem = getDomainNamePayloadFromConfig(newconfigurations[uuid], newconfigurations)
            const hostingList = getFilteredConfigurationList(SHARED_HOSTING_TYPE, newconfigurations, false, true,true)
            if(domainItem){
                domainItem.uuid = uuid
                domainItem.action = "edit"
                let items = [domainItem]
                if(hostingList && hostingList.length){
                    let hostingitem = hostingList[0]
                    items.push(hostingitem)
                }
                bulkActionCart(dispatch,history,items,'?a=checkout')
            }
        }else{
            const {uuid} = getDataFromURL(location.search)
            const items = getDomainNamePayloadFromConfig(newconfigurations[uuid], newconfigurations)
            const payload = {
                token: getCartToken(),
                items,
                uuid
            }
            updateCartItem(payload, dispatch, history, '?a=checkout')
        }
    }

    const onSubmit = (values) =>{
        let newconfigurations = JSON.parse(localStorage.configurations)

        //clear timeout
        if(timeoutOnSubmit){
            window.clearTimeout(timeoutOnSubmit)
        }

        //update configurations
        if (formValuesAreDefined(values)) {
            const {domain_config} = values
            if (domain_config && domain_config.length) {
                domain_config.forEach((dataInput) => {
                    const {domain, tld} = dataInput
                    if (domain && tld) {
                        switch (pageType){
                            case ADD_DOMAIN_PAGE:
                            case EDIT_DOMAIN_PAGE:
                                newconfigurations = getNewConfigurationsOnDomainPage(dataInput,newconfigurations)
                                break
                            case EDIT_PRODUCT_PAGE:
                            case ADD_PRODUCT_PAGE:
                                newconfigurations = getNewConfigurationsOnProductPage(dataInput,newconfigurations)
                                break
                            default:
                                break
                        }
                    }
                })

                if (newconfigurations && Object.keys(newconfigurations) && Object.keys(newconfigurations).length) {
                    //process configurations
                    switch (pageType){
                        case ADD_DOMAIN_PAGE:
                            processConfigurationsOnAddDomainPage(newconfigurations)
                            break
                        case EDIT_DOMAIN_PAGE:
                            processConfigurationsOnEditDomainPage(newconfigurations)
                            break
                        case ADD_PRODUCT_PAGE:
                            processConfigurationsOnAddProductPage(newconfigurations)
                            break
                        case EDIT_PRODUCT_PAGE:
                            console.log(newconfigurations)
                            processConfigurationsOnEditProductPage(newconfigurations)
                            break
                        default:
                            break
                    }
                }
            }
        }


    }

    return ({
        domainConfigFormSubmit: onSubmit
    })
}